module.exports = __webpack_public_path__ + "static/media/model-l200-06.17ca9770.webp";